/**
 * Landing navbar – professional, government-facing
 */

import React from 'react';
import { LandingBeamButton } from './LandingBeamButton';
import styles from './LandingShared.module.css';
import type { LandingBranding } from './landingBranding';

export interface LandingNavbarProps {
  branding: LandingBranding;
  loginHref: string;
  variant?: 'light' | 'dark';
}

export function LandingNavbar({ branding, loginHref, variant = 'dark' }: LandingNavbarProps) {
  const navClass = variant === 'light' ? styles.navbarLight : styles.navbarGlass;
  return (
    <header
      className={`sticky top-0 z-50 ${navClass}`}
      style={{ padding: '8px 0 12px' }}
    >
      <div className="mx-auto flex w-full max-w-6xl items-center justify-between gap-4 px-4 sm:px-6">
        <div className="flex min-w-0 flex-col gap-0.5">
          <div className="flex items-center gap-3">
            {branding.logoUrl ? (
              <img
                src={branding.logoUrl}
                alt={branding.logoAlt ?? branding.appName}
                className="h-14 w-auto max-h-16 max-w-[min(520px,80vw)] object-contain object-left sm:h-14"
                style={{ color: branding.primaryColor }}
              />
            ) : (
              <span
                className="text-xl font-bold"
                style={{ color: branding.primaryColor }}
              >
                {branding.appName}
              </span>
            )}
          </div>
          {branding.subtitle && (
            <span className={`text-xs font-medium hidden sm:block ${variant === 'light' ? 'text-slate-600' : 'text-slate-400'}`}>
              {branding.subtitle}
            </span>
          )}
        </div>
        <LandingBeamButton href={loginHref} primaryColor={branding.primaryColor}>
          Log in
        </LandingBeamButton>
      </div>
    </header>
  );
}
